import { View } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';
import Svg, { Path } from 'react-native-svg';

const PatternBackground = ({ color }) => {
    const { theme: { colors }, rt } = useUnistyles();
    const primary = color || colors.primary;
    const secondary = color || colors.secondary;
    // Light scheme washes the strokes out — bump them a step over dark.
    const isLight = rt.themeName !== 'dark';
    const thin = isLight ? 0.12 : 0.08;
    const mid = isLight ? 0.12 : 0.08;
    const wide = isLight ? 0.055 : 0.036;

    return (
        <View testID="app-background-pattern" pointerEvents="none" accessibilityElementsHidden importantForAccessibility="no-hide-descendants" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden'}}>
            <Svg width="100%" height="100%" viewBox="0 0 1440 1000" preserveAspectRatio="xMidYMid slice" fill="none">
                <Path d="M-160 800H150L350 600V320L530 140H870L1100-90" stroke={primary} strokeWidth={1} opacity={thin} />
                <Path d="M100 1120V880L290 690H560L760 490H1150L1510 130" stroke={secondary} strokeWidth={1.5} opacity={mid} />
                <Path d="M1080 1150V800L1240 640H1520" stroke={primary} strokeWidth={1} opacity={thin} />
                <Path d="M-80 220H120L340 0" stroke={secondary} strokeWidth={28} opacity={wide} />
                <Path d="M1190 1010L1450 750" stroke={primary} strokeWidth={48} opacity={wide} />
            </Svg>
        </View>
    );
}

export {PatternBackground}
